export default {
  info: state => state.info,
  loading: state => state.loading,
  on: state => state.on,
}
